// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import {
    filterContactRequests,
    loadContactRequests,
    loadContactRequestRegions,
    regionsContactRequests,
    showDeleteContactRequestPrompt,
    deletePromptReset,
    removeContactRequest,
} from '../../redux/reducers/contactrequests';

import List from '../../components/ContactRequests/List';
import Filter from '../../components/ContactRequests/Filter';
import { REPORT_TYPES, getExportDownload } from '../../redux/reducers/exports';

import ContactRequestDetailModal from '../../components/ContactRequests/ContactRequestDetailModal';

import Pagination from '../../components/shared/Pagination';

import Loader from '../../components/Loader/Loader';
import DeleteContactRequestModal from '../../components/ContactRequests/DeleteModal';

import { colors } from '../../shared/styles';

const ContactRequestsWrapper = styled.div`
    display: flex;
    position: relative;

    .list {
        background: ${colors.white};
        flex-grow: 1;
    }

    .list-wrapper {
        background: ${colors.white};
        height: calc(100vh - 152px);
        overflow: hidden;
    }

    .filter {
        flex: 0 0 300px;
        background: ${colors.grey.default};
        color: ${colors.white};

        .btn {
            display: block;
            background: ${colors.orange.default};
            color: ${colors.white};
            border-radius: 4px;
            text-align: center;
            text-decoration: none;
            padding: 12px 0;
            width: 100%;
            border: 0;
            font-size: 16px;
        }

        .search-section {
            padding: 20px;
            border-bottom: solid 1px ${colors.grey.light};
        }

        h2 {
            margin: 0;
            padding: 20px 30px 20px 30px;
            font-weight: lighter;
            border-bottom: solid 1px ${colors.grey.light};
        }
    }

    .stats {
        display: block;
        text-align: center;
        font-size: 14px;
        font-stretch: normal;
        color: ${colors.darkBlue.default};
    }
`;

class ContactRequests extends Component {
    onFilterChange: Function;
    onCheckBoxChange: Function;
    onFilterReset: Function;
    onFilterSubmit: Function;
    onReset: Function;
    onPageChange: Function;
    onContactRequest: Function;
    onHideContactRequest: Function;
    getDataExport: Function;
    state: Object;
    onDelete: Function;
    confirmDelete: Function;
    deletePromptReset: Function;
    refresh: Function;

    constructor(props) {
        super(props);

        this.onFilterChange = this.onFilterChange.bind(this);
        this.onCheckBoxChange = this.onCheckBoxChange.bind(this);
        this.onFilterReset = this.onFilterReset.bind(this);
        this.onFilterSubmit = this.onFilterSubmit.bind(this);
        this.onReset = this.onReset.bind(this);
        this.onPageChange = this.onPageChange.bind(this);
        this.onContactRequest = this.onContactRequest.bind(this);
        this.onHideContactRequest = this.onHideContactRequest.bind(this);
        this.getDataExport = this.getDataExport.bind(this);
        this.state = {
            viewingContactRequestId: null,
        };
        this.onDelete = this.onDelete.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);
        this.deletePromptReset = this.deletePromptReset.bind(this);
        this.refresh = this.refresh.bind(this);
    }

    getDataExport() {
        this.props.dispatch(
            getExportDownload(REPORT_TYPES.CONTACT_REGION_REQUESTS)
        );
    }

    componentDidMount() {
        this.props.dispatch(loadContactRequests(1));
        this.props.dispatch(loadContactRequestRegions());
    }

    onFilterChange(e) {
        this.props.dispatch(filterContactRequests(e.target.value));
    }

    onCheckBoxChange(e) {
        let tempFilterRegions =
            this.props.filterRegions !== null ? this.props.filterRegions : [];
        if (tempFilterRegions[e.target.value] !== undefined) {
            delete tempFilterRegions[e.target.value];
        } else {
            tempFilterRegions[e.target.value] = e.target.value;
        }

        this.props.dispatch(regionsContactRequests(tempFilterRegions));
        this.props.dispatch(loadContactRequests(1));
    }

    onFilterReset() {
        this.props.dispatch(filterContactRequests(''));
        this.props.dispatch(regionsContactRequests([]));

        this.props.dispatch(loadContactRequests(1));
    }

    onFilterSubmit(e) {
        e.preventDefault();
        this.props.dispatch(loadContactRequests(1));
    }

    onReset() {
        this.props.dispatch(loadContactRequests(1));
    }

    onPageChange(pageNo) {
        this.props.dispatch(loadContactRequests(pageNo));
    }

    onContactRequest(contactRequestId) {
        this.setState({
            viewingContactRequestId: contactRequestId,
        });
    }

    onHideContactRequest() {
        this.setState({
            viewingContactRequestId: null,
        });
    }

    onDelete(contactRequest) {
        console.log('contactRequest', contactRequest);
        this.props.dispatch(
            showDeleteContactRequestPrompt(
                contactRequest.contactRequestId,
                contactRequest.contactRequestName
            )
        );
    }

    confirmDelete() {
        const {
            dispatch,
            deletePrompt: { contactRequestId, contactRequestName },
        } = this.props;

        dispatch(
            removeContactRequest(contactRequestId, contactRequestName)
        ).then(() => {
            this.refresh();
        });
    }

    deletePromptReset() {
        this.props.dispatch(deletePromptReset());
    }

    refresh() {
        this.setState({
            refreshing: true,
        });

        setTimeout(() => {
            this.props.dispatch(loadContactRequests(1));
            this.setState({
                refreshing: false,
            });
        }, 500);
    }

    render() {
        const {
            contactRequests,
            filter,
            isFetching,
            pagination,
            total,
            fetchingTime,
            contactRequestRegions,
            fetching,
            filterRegions,
            deletePrompt,
        } = this.props;

        const { viewingContactRequestId } = this.state;
        const downloadText = fetching
            ? 'Please wait...'
            : 'Download Connected requests';

        const contactRequestDetail =
            viewingContactRequestId && contactRequests[viewingContactRequestId]
                ? contactRequests[viewingContactRequestId]
                : null;

        return (
            <ContactRequestsWrapper>
                <DeleteContactRequestModal
                    isOpen={deletePrompt.visible}
                    removing={deletePrompt.removing}
                    contactRequestName={deletePrompt.contactRequestName}
                    onCancel={this.deletePromptReset}
                    onConfirmDelete={this.confirmDelete}
                />
                <ContactRequestDetailModal
                    contactRequest={contactRequestDetail}
                    isOpen={viewingContactRequestId !== null}
                    onCancel={this.onHideContactRequest}
                />

                <Filter
                    filter={filter}
                    onFilterChange={this.onFilterChange}
                    onFilterReset={this.onFilterReset}
                    onFilterSubmit={this.onFilterSubmit}
                    total={total}
                    fetchingTime={fetchingTime}
                    suffix={'Contact Request'}
                    exportOnClick={e => {
                        this.getDataExport();
                    }}
                    exportFetching={fetching}
                    downloadText={downloadText}
                    contactRequestRegions={contactRequestRegions}
                    onCheckBoxChange={this.onCheckBoxChange}
                    filterRegions={filterRegions}
                />

                <div className="list">
                    <div className="list-wrapper">
                        {(isFetching || !contactRequests) &&
                            <Loader message="Loading contact requests, please wait..." />}

                        {!isFetching &&
                            contactRequests &&
                            <List
                                contactRequests={contactRequests}
                                onContactRequest={this.onContactRequest}
                                onDelete={this.onDelete}
                            />}
                    </div>
                    <Pagination
                        onPageChange={this.onPageChange}
                        pagination={pagination}
                    />
                </div>
            </ContactRequestsWrapper>
        );
    }
}

const mapStateToProps = state => {
    const list = state.contactrequests.list;
    const remove = state.contactrequests.remove;
    console.log('remove', remove);

    return {
        errorFetching: list.error,
        filter: list.filter,
        filterRegions: list.regions,
        isFetching: list.fetching,
        contactRequests: list.contactRequests,
        pagination: list.pagination,
        total: list.pagination.total,
        fetchingTime: list.fetchingTime,
        contactRequestRegions: state.contactrequests.regions.list,
        deletePrompt: {
            contactRequestId: remove.contactRequestId,
            contactRequestName: remove.contactRequestName,
            removing: remove.removing,
            visible: Boolean(
                remove.contactRequestId && remove.contactRequestName
            ),
        },
    };
};

export default connect(mapStateToProps)(ContactRequests);



// WEBPACK FOOTER //
// ./src/containers/ContactRequests/ContactRequests.js